import { formatNumber } from '@angular/common';
import { isNumber, isInt } from '../type-checkers';

// ToDo: Check out why jsdoc annotation fails the build
// /**
//  * Returns formatted number with floating points, adds leading sign before it.
//  * (uses angular formatNumber function from common api)
//  *
//  * @param  {number} value
//  * @param  {string} locale
//  * @param  {{int:string;float:string;}} digitsInfo
//  * @returns string
//  */
export const formatNumberWithLeadingSign = (
  value: number,
  locale: string,
  digitsInfo: {
    int: string;
    float: string;
  }
): string => {
  if (!isNumber(value)) {
    return `${value || ''}`;
  }

  const isPositive: boolean = value >= 0;

  if (isPositive) {
    if (isInt(value)) {
      return `+${formatNumber(value, locale, digitsInfo.int)}`;
    }

    return `+${formatNumber(value, locale, digitsInfo.float)}`;
  } else {
    if (isInt(value)) {
      return `${formatNumber(value, locale, digitsInfo.int)}`;
    }

    return `${formatNumber(value, locale, digitsInfo.float)}`;
  }
};
